require( 'slick-carousel-latest' );
( function ( $ ) {
  let winWidth = $( window ).width();

  const appendCustomAttributesToSlider = () => {
    // Auto sliding tab slider
    $('.r-tabslr-l8--sfbr1').each((index, element) => {
      const slider = $(element).find('.bs-slider-content.slick-slider');
      let slickData = slider.data('slick');
      Object.values(slickData.responsive).map((point) => {
        point.settings.pauseOnHover = false;
      });
      slider.data('slick', slickData);
    });
  }

  const initSlickSlide = (initLogoSlider = true) => {
    const selectors = ['.slick-initialized'];
    if (!initLogoSlider) {
      selectors.append('.bs-logo-slider__inner');
    }
    if ( $( '[data-slick]' ).length ) {
      $( '[data-slick]' ).not( selectors.join(',') ).slick();
    }
  };

  appendCustomAttributesToSlider();
  initSlickSlide();

} )( jQuery );
